<template>
  <section class="banner-section pt-0 pb-0 overflow-hidden relative">
    <!-- <div class="d-flex justify-content-center top_bar mb-4">
      <div class="dropdown" ref="dropdownRef">
        <button
          class="btn d-flex text-white gap-1 align-items-center dropdown_control"
          @click="toggleDropdown"
          type="button"
        >
          Find Events
          <svg
            width="6"
            height="5"
            viewBox="0 0 6 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.62491 0.458242L0.374914 0.458241C0.32176 0.458408 0.269658 0.473068 0.224217 0.500643C0.178775 0.528219 0.141714 0.567665 0.117024 0.614736C0.0923327 0.661807 0.0809473 0.714721 0.0840925 0.767782C0.0872372 0.820843 0.104794 0.872041 0.134872 0.915866L2.75987 4.70753C2.86866 4.86474 3.13058 4.86474 3.23966 4.70753L5.86466 0.915867C5.89505 0.872133 5.91287 0.820909 5.91618 0.76776C5.9195 0.714611 5.90819 0.661569 5.88347 0.614398C5.85876 0.567227 5.82159 0.52773 5.77601 0.5002C5.73042 0.47267 5.67817 0.458158 5.62491 0.458242Z"
              fill="white"
            />
          </svg>
        </button>

        <div
          v-if="isOpen"
          class="dropdown_main_wrapper"
          style="min-width: 250px"
        >
          <a
            href="#"
            class="d-flex align-items-start mb-3 text-decoration-none"
            @click.prevent="searchEvent('upcoming')"
          >
            <div class="me-2 text-danger">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 22H16C15.7167 22 15.4793 21.904 15.288 21.712C15.0967 21.52 15.0007 21.2827 15 21C14.9993 20.7173 15.0953 20.48 15.288 20.288C15.4807 20.096 15.718 20 16 20H19V10H5V13C5 13.2833 4.904 13.521 4.712 13.713C4.52 13.905 4.28267 14.0007 4 14C3.71734 13.9993 3.48 13.9033 3.288 13.712C3.096 13.5207 3 13.2833 3 13V6C3 5.45 3.196 4.97934 3.588 4.588C3.98 4.19667 4.45067 4.00067 5 4H6V3C6 2.71667 6.096 2.47934 6.288 2.288C6.48 2.09667 6.71734 2.00067 7 2C7.28267 1.99934 7.52034 2.09534 7.713 2.288C7.90567 2.48067 8.00134 2.718 8 3V4H16V3C16 2.71667 16.096 2.47934 16.288 2.288C16.48 2.09667 16.7173 2.00067 17 2C17.2827 1.99934 17.5203 2.09534 17.713 2.288C17.9057 2.48067 18.0013 2.718 18 3V4H19C19.55 4 20.021 4.196 20.413 4.588C20.805 4.98 21.0007 5.45067 21 6V20C21 20.55 20.8043 21.021 20.413 21.413C20.0217 21.805 19.5507 22.0007 19 22ZM9.175 20H2C1.71667 20 1.47934 19.904 1.288 19.712C1.09667 19.52 1.00067 19.2827 1 19C0.999337 18.7173 1.09534 18.48 1.288 18.288C1.48067 18.096 1.718 18 2 18H9.175L7.3 16.1C7.11667 15.9167 7.021 15.6877 7.013 15.413C7.005 15.1383 7.10067 14.9007 7.3 14.7C7.48334 14.5167 7.71667 14.425 8 14.425C8.28334 14.425 8.51667 14.5167 8.7 14.7L12.3 18.3C12.5 18.5 12.6 18.7333 12.6 19C12.6 19.2667 12.5 19.5 12.3 19.7L8.7 23.3C8.51667 23.4833 8.28767 23.5793 8.013 23.588C7.73834 23.5967 7.50067 23.5007 7.3 23.3C7.11667 23.1167 7.025 22.8833 7.025 22.6C7.025 22.3167 7.11667 22.0833 7.3 21.9L9.175 20Z"
                  fill="#F05537"
                />
              </svg>
            </div>
            <div class="flex-fill drop_content">
              <p class="mb-1 text-dark">Upcoming</p>
              <span class="mb-0 text-secondary small"
                >Explore upcoming cultural events near you</span
              >
            </div>
          </a>

          <a
            href="#"
            class="d-flex align-items-start mb-3 text-decoration-none"
            @click="triggerScroll('featured')"
          >
            <div class="me-2 text-danger">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.15299 5.408C10.42 3.136 11.053 2 12 2C12.947 2 13.58 3.136 14.847 5.408L15.175 5.996C15.535 6.642 15.715 6.965 15.995 7.178C16.275 7.391 16.625 7.47 17.325 7.628L17.961 7.772C20.421 8.329 21.65 8.607 21.943 9.548C22.235 10.488 21.397 11.469 19.72 13.43L19.286 13.937C18.81 14.494 18.571 14.773 18.464 15.117C18.357 15.462 18.393 15.834 18.465 16.577L18.531 17.254C18.784 19.871 18.911 21.179 18.145 21.76C17.379 22.341 16.227 21.811 13.925 20.751L13.328 20.477C12.674 20.175 12.347 20.025 12 20.025C11.653 20.025 11.326 20.175 10.672 20.477L10.076 20.751C7.77299 21.811 6.62099 22.341 5.85599 21.761C5.08899 21.179 5.21599 19.871 5.46899 17.254L5.53499 16.578C5.60699 15.834 5.64299 15.462 5.53499 15.118C5.42899 14.773 5.18999 14.494 4.71399 13.938L4.27999 13.43C2.60299 11.47 1.76499 10.489 2.05699 9.548C2.34899 8.607 3.57999 8.328 6.03999 7.772L6.67599 7.628C7.37499 7.47 7.72499 7.391 8.00499 7.178C8.28599 6.965 8.46499 6.642 8.82499 5.996L9.15299 5.408Z"
                  stroke="#F05537"
                  stroke-width="1.5"
                />
              </svg>
            </div>
            <div class="flex-fill drop_content">
              <p class="mb-1 text-dark">Featured</p>
              <span class="mb-0 text-secondary small"
                >Top events you won't want to miss</span
              >
            </div>
          </a>

          <a
            href="#newest"
            class="d-flex align-items-start text-decoration-none"
            @click.prevent="searchEvent('newest')"
          >
            <div class="me-2 text-danger">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 4C18.2652 4 18.5196 4.10536 18.7071 4.29289C18.8946 4.48043 19 4.73478 19 5V13C19 13.2652 18.8946 13.5196 18.7071 13.7071C18.5196 13.8946 18.2652 14 18 14C17.7348 14 17.4804 13.8946 17.2929 13.7071C17.1054 13.5196 17 13.2652 17 13V5C17 4.73478 17.1054 4.48043 17.2929 4.29289C17.4804 4.10536 17.7348 4 18 4ZM4 18C4 17.7348 4.10536 17.4804 4.29289 17.2929C4.48043 17.1054 4.73478 17 5 17H13C13.2652 17 13.5196 17.1054 13.7071 17.2929C13.8946 17.4804 14 17.7348 14 18C14 18.2652 13.8946 18.5196 13.7071 18.7071C13.5196 18.8946 13.2652 19 13 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18ZM7.707 6.293C7.5184 6.11084 7.2658 6.01005 7.0036 6.01233C6.7414 6.0146 6.49059 6.11977 6.30518 6.30518C6.11977 6.49059 6.0146 6.7414 6.01233 7.0036C6.01005 7.2658 6.11084 7.5184 6.293 7.707L13.293 14.707C13.4816 14.8892 13.7342 14.99 13.9964 14.9877C14.2586 14.9854 14.5094 14.8802 14.6948 14.6948C14.8802 14.5094 14.9854 14.2586 14.9877 13.9964C14.99 13.7342 14.8892 13.4816 14.707 13.293L7.707 6.293Z"
                  fill="#F05537"
                />
              </svg>
            </div>
            <div class="flex-fill drop_content">
              <p class="mb-1 text-dark">Newest</p>
              <span class="mb-0 text-secondary small"
                >Check out the latest events</span
              >
            </div>
          </a>
        </div>
      </div>
    </div> -->

    <!-- Custom fade slider — full control, no CSS fighting with vue3-carousel internals -->
    <div class="slides-wrapper">
      <div
        v-for="(content, index) in pageContent?.media"
        :key="index"
        class="fade-slide"
        :class="{ 'is-active': currentSlide === index, 'is-ready': slideReady }"
      >
        <HeroSliderContent
          :button-click-handler="() => {}"
          :title="content?.title"
          :description="content?.description"
          is-live-media
          :image-source="content?.banner"
          :link="content?.link"
          :showButton="content.showButton"
          :buttonText="content.buttonText"
          :bannerlink="content.bannerlink"
        />
      </div>
      <ol class="carousel__pagination slides-pagination">
        <li
          v-for="(_, index) in pageContent?.media"
          :key="index"
          class="carousel__pagination-item"
        >
          <button
            class="carousel__pagination-button"
            :class="{ 'carousel__pagination-button--active': currentSlide === index }"
            @click="goToSlide(index)"
            :aria-label="'Go to slide ' + (index + 1)"
          />
        </li>
      </ol>
    </div>

    <div class="overlay_cover"></div>

    <div class="banner-form-container">
      <div class="container">
        <div class="hero-split-layout">
          <!-- Left: dynamic slide content -->
          <div class="hero-content-side">
            <Transition name="hero-content-fade" mode="out-in">
              <div :key="currentSlide" class="hero-slide-text">
                <h1 class="hero-slide-title" v-if="activeSlideTitle">{{ activeSlideTitle }}</h1>
                <p class="hero-slide-desc" v-if="activeSlideDescription">{{ activeSlideDescription }}</p>
                <div class="hero-slide-ctas" v-if="(activeSlideShowButton && activeSlideLink) || activeSlideBannerlink">
                  <a
                    v-if="activeSlideShowButton && activeSlideLink"
                    :href="activeSlideLink"
                    class="primary-bg text-white hero-cta-btn"
                  >{{ activeSlideButtonText }}</a>
                  <a
                    v-else-if="activeSlideBannerlink"
                    :href="activeSlideBannerlink"
                    class="primary-bg text-white hero-cta-btn"
                  >More Info</a>
                </div>
              </div>
            </Transition>
          </div>

          <!-- Right: search card -->
          <div class="hero-form-side">
            <TopBarSearchForm />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import HeroSliderContent from "@/components/presentational/home/hero-slider-content";
import TopBarSearchForm from "@/components/stateful/home/top-bar-search-form";
import 'vue3-carousel/dist/carousel.css';
import {
  onMounted,
  ref,
  computed,
  onBeforeUnmount,
} from "vue";
import ApiClient from "@/methods/apiclient";
import { useRouter } from "vue-router";
import { ROUTES } from "@/utils/constants/routes";

const router = useRouter();
const isOpen = ref(false);
const dropdownRef = ref(null);
const slideReady = ref(false);
const emit = defineEmits(["scroll-to"]);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const onClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

const pageContent = ref({});
const currentSlide = ref(0);
let autoplayTimer = null;

const totalSlides = computed(() => pageContent.value?.media?.length || 0);

const activeSlideTitle = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.title || ""
);
const activeSlideDescription = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.description || ""
);
const activeSlideShowButton = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.showButton || false
);
const activeSlideButtonText = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.buttonText || ""
);
const activeSlideLink = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.link || ""
);
const activeSlideBannerlink = computed(
  () => pageContent.value?.media?.[currentSlide.value]?.bannerlink || ""
);

const goToSlide = (index) => {
  currentSlide.value = index;
};

const nextSlide = () => {
  if (totalSlides.value > 0) {
    currentSlide.value = (currentSlide.value + 1) % totalSlides.value;
  }
};

onMounted(() => {
  document.addEventListener("click", onClickOutside);
  setTimeout(() => {
    slideReady.value = true;
  }, 50);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onClickOutside);
  clearInterval(autoplayTimer);
});

onMounted(async () => {
  try {
    const response = await ApiClient.get(
      `page-content/page-name?pageName=Home`,
    );
    pageContent.value = response.data;
    autoplayTimer = setInterval(nextSlide, 4000);
  } catch (error) {
    // Handle errors
  }
});

const longitude = ref(0);
const latitude = ref(0);
const patchLatng = () => {
  latitude.value = Number(localStorage.getItem("alat") || 0);
  longitude.value = Number(localStorage.getItem("alng") || 0);
};
patchLatng();

const searchEvent = (title) => {
  let parms = {
    lat: latitude.value ?? "",
    lng: longitude.value ?? "",
    q: title,
  };
  router.push({ name: ROUTES.SEARCH, query: parms });
};

function triggerScroll(refName) {
  emit("scroll-to", refName);
}
</script>

<style scoped>
.dropdown_main_wrapper {
  position: absolute;
  transform: translateX(-24%);
  background-color: #fff;
  z-index: 99999;
  padding: 14px;
  border-radius: 14px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  top: 44px;
}

.drop_content p {
  font-size: 14px;
  font-weight: 600;
}

.drop_content span {
  font-weight: 500;
  font-size: 12px;
}

.top_bar {
  padding: 16px 0;
  border-bottom: 1px solid #ffffff3d;
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
  z-index: 9;
}

.dropdown_control {
  font-weight: 500;
  font-size: 18px;
  background-color: #f05537;
}

/* Fade slider */
.slides-wrapper {
  position: relative;
  overflow: hidden;
  height: 450px;
}

.fade-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
}

.fade-slide.is-ready {
  transition: opacity 1.5s ease-in-out;
}

.fade-slide.is-active {
  opacity: 1;
  pointer-events: auto;
}

.slides-pagination {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 !important;
  z-index: 10;
}

.carousel__pagination-button {
  cursor: pointer;
}

@media only screen and (max-width: 991px) {
  .slides-wrapper {
    height: 600px;
  }
}

@media only screen and (max-width: 575px) {
  .slides-wrapper {
    height: 780px;
  }
}

/* Overlay gradient: light on left (for dark text), transparent on right (card floats on image) */
.overlay_cover {
  background: linear-gradient(to right, rgba(255,255,255,0.78) 0%, rgba(255,255,255,0.6) 48%, rgba(255,255,255,0.05) 100%);
  position: absolute;
  inset: 0;
  pointer-events: none;
}

/* Split layout */
.banner-form-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
}

.hero-split-layout {
  display: flex;
  align-items: center;
  gap: 48px;
  width: 100%;
}

.hero-content-side {
  flex: 1;
  min-width: 0;
}

.hero-form-side {
  width: 400px;
  flex-shrink: 0;
}

/* Slide text */
.hero-slide-title {
  font-size: 36px;
  font-weight: 800;
  color: #111;
  line-height: 1.2;
  margin-bottom: 12px;
}

.hero-slide-desc {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  margin-bottom: 24px;
  max-width: 420px;
}

.hero-cta-btn {
  display: inline-block;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid transparent;
  transition: all 0.3s;
}

.hero-cta-btn:hover {
  background: transparent !important;
  color: #f05537 !important;
  border-color: #f05537;
}

/* Slide content fade transition */
.hero-content-fade-enter-active,
.hero-content-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.hero-content-fade-enter-from {
  opacity: 0;
  transform: translateY(12px);
}

.hero-content-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Responsive */
@media (max-width: 991px) {
  .hero-split-layout {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 24px;
  }

  .hero-form-side {
    width: 100%;
  }

  .hero-slide-title {
    font-size: 26px;
  }
}

</style>
